module.exports = __webpack_public_path__ + "img/Bathroom.620fe954.png";